module.exports = __webpack_public_path__ + "static/media/refresh.6456276d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/refresh.svg
// module id = 538
// module chunks = 33